import { useDemoTheme } from './DemoThemeContext';

export default function GridQuestion({ question, gridAnswers = {}, onGridChange }) {
  const { isDark } = useDemoTheme();

  const handleChange = (cellKey, value) => {
    onGridChange(question.id, { ...gridAnswers, [cellKey]: value });
  };

  return (
    <div data-testid={`grid-question-${question.id}`} className="overflow-x-auto">
      <table className="w-full border-collapse text-xs font-mono">
        <thead>
          <tr>
            <th className="px-4 py-3 text-left font-medium" style={{ color: 'var(--d-text-3)', borderBottom: '1px solid var(--d-border)', background: 'var(--d-subtle)', minWidth: 130 }}>
              Data Structure
            </th>
            {question.cols.map((col) => (
              <th key={col} className="px-4 py-3 text-center font-medium" style={{ color: 'var(--d-text-3)', borderBottom: '1px solid var(--d-border)', background: 'var(--d-subtle)', minWidth: 110 }}>
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {question.rows.map((row, rowIdx) => (
            <tr key={row} style={{ borderBottom: rowIdx < question.rows.length - 1 ? '1px solid var(--d-border-sub)' : 'none' }}>
              <td className="px-4 py-3 font-medium" style={{ color: 'var(--d-text-1)', whiteSpace: 'nowrap' }}>{row}</td>
              {question.cols.map((_, colIdx) => {
                const key = `${rowIdx}_${colIdx}`;
                const prefilled = question.cells[key];
                const isBlank = prefilled === null;
                const userValue = gridAnswers[key] || '';
                return (
                  <td key={key} className="px-3 py-2 text-center">
                    {isBlank ? (
                      <input
                        data-testid={`grid-cell-${question.id}-${key}`}
                        type="text" value={userValue} onChange={(e) => handleChange(key, e.target.value)}
                        placeholder="O(?)"
                        className="w-full text-center rounded-lg px-3 py-2 text-xs font-mono outline-none transition-all duration-200"
                        style={{
                          background: 'rgba(124,58,237,0.07)',
                          border: userValue ? '1px solid rgba(124,58,237,0.45)' : '1px solid var(--d-border)',
                          color: userValue ? (isDark ? '#c4b5fd' : '#5b21b6') : 'var(--d-text-3)',
                          caretColor: '#a78bfa',
                        }}
                        onFocus={(e) => { e.target.style.border = '1px solid rgba(124,58,237,0.6)'; e.target.style.boxShadow = '0 0 0 3px rgba(124,58,237,0.1)'; }}
                        onBlur={(e) => { e.target.style.border = userValue ? '1px solid rgba(124,58,237,0.45)' : '1px solid var(--d-border)'; e.target.style.boxShadow = 'none'; }}
                      />
                    ) : (
                      <span className="px-3 py-2 rounded-lg inline-block" style={{ color: 'var(--d-text-2)', background: 'var(--d-subtle)', border: '1px solid var(--d-border-sub)' }}>
                        {prefilled}
                      </span>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
      <p className="mt-4 text-xs" style={{ color: 'var(--d-text-3)' }}>
        * Insert for Linked List assumes insertion at head. Average-case for Hash Table.
      </p>
    </div>
  );
}
